import { render, staticRenderFns } from "./BudgetPlanning.vue?vue&type=template&id=0d894177&"
import script from "./BudgetPlanning.vue?vue&type=script&lang=js&"
export * from "./BudgetPlanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports